export default __webpack_public_path__ + "static/fertilizing-23c132396825ba56a43c92e0f3c6be5a.webp";